import { transformNotificationResponse } from 'core/modules/notifications/notification.transformer';
import { Logger } from 'core/utils/logger';
import { createContext, useContext, useEffect, useState } from 'react';
import socketIOClient from 'socket.io-client';
import { config } from 'src/config';
var logger = new Logger('websockets.store');
export function useWebSocketsStore(auth, notifications) {
  // State
  var _useState = useState(false),
      isLoading = _useState[0],
      setLoading = _useState[1];

  var connect = function connect() {
    setLoading(true);

    try {
      var host = true ? "wss://".concat(window.location.host.replace(/:.*/, '')) : "ws://".concat(window.location.host.replace(/:.*/, ''), ":").concat(config.websocketPort);
      var socket = socketIOClient("".concat(host, "/notifications"), {
        path: '/ws',
        transports: ['websocket'],
        // This only works with HTTP transports
        extraHeaders: {
          authorization: "Bearer ".concat(auth.jwt)
        },
        // This works with the websocket-only transport
        auth: {
          token: auth.jwt
        }
      });
      socket.connect();
      socket.on('created', function (notification) {
        notifications.addNotification(transformNotificationResponse(notification));
      });
      return socket;
    } catch (error) {
      logger.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(function () {
    var socket = auth.isAuthenticated ? connect() : undefined;
    return function () {
      socket === null || socket === void 0 ? void 0 : socket.disconnect();
    };
  }, [auth.isAuthenticated]);
  return {
    isLoading: isLoading
  };
}
export var WebSocketsStoreContext = /*#__PURE__*/createContext({
  isLoading: true
});
export function getWebSocketsStore() {
  return useContext(WebSocketsStoreContext);
}